module.exports = __webpack_public_path__ + "static/media/heart_empty.4278f6ba.svg";